// extracted by mini-css-extract-plugin
module.exports = {"container":"policy_container__uWrx_","text":"policy_text__SJ_T0"};